var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full h-5 border border-primary rounded-lg overflow-hidden"},[_c('div',{staticClass:"inline-block h-full bg-orange-300 max-w-full",style:({ width: _vm.progress + '%' })})])}
var staticRenderFns = []

export { render, staticRenderFns }